import { Button } from '@opendoor/mosaic';

import { GetWorkOrder_homework_getWorkOrder_address } from '../../graphql/athena/types/GetWorkOrder';
import { WEB_URL } from '../../utils/constants';

interface AddressHeaderProps {
  address: GetWorkOrder_homework_getWorkOrder_address | null;
}

const AddressHeader = ({ address }: AddressHeaderProps) => {
  return (
    <div className={`flex justify-between items-center ph-6 ${styles.addressContainer}`}>
      <div>
        <h1 style={styles.addressFirstLine}>{address?.street}</h1>
        <h3 style={styles.addressSecondLine}>
          {address?.city}
          {address?.city ? ',' : ''} {address?.state} {address?.postalCode}
        </h3>
      </div>
      <a href={WEB_URL + '/vendor/work-orders'}>
        <Button variant="outlined" size="small">
          Back to Work Orders
        </Button>
      </a>
    </div>
  );
};

const styles = {
  addressContainer: {
    background: '#f7f7f7',
  },
  addressFirstLine: {
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontSize: '1.5rem',
    marginBottom: 0,
    lineHeight: 1.1,
  },
  addressSecondLine: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '1rem',
    color: '#777',
    marginTop: '5px',
  },
};

export default AddressHeader;
